export default function checkIfSafariBrowser(): boolean | undefined {
  if (typeof navigator === 'undefined' || !navigator) return
  const ua = navigator?.userAgent
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua)
  return isSafari
}
